import {RolePermissionType} from '../backend/enums/role-permission-type';
import {useAuth} from '../contexts/auth/context';

/**
 * The registry of the attendance tracker is for users that can read it, and only while the attendance
 * tracker is enabled in the entity (in the settings of the entity).
 */
export const useCanViewAttendanceTrackerRegistry = (): boolean => {
  const {state, hasReadPermission} = useAuth();

  return (
    hasReadPermission(RolePermissionType.Team_AttendanceTracker_Registry) &&
    state.session?.selectedAffiliation?.attendanceTracker?.isEnabled === true
  );
};
